import { DeepPartial, Messages } from '@empathybroker/ebx-gluon';

export const fr: DeepPartial<Messages> = {
  resultsFoundHTML: '<span class="ebx-results-number__count">{resultsNumber}</span> résultats',
  nextQueriesSuggestions: {
    title: 'L\'utilisateur qui rechercha {query} a également recherché...'
  },
  search: {
    inputPlaceholderAlternativesHTML: ['Que recherchez-vous?']
  },
  facets: {
    clearFilters: 'Effacer filtres',

    toggle: {
      groups: {
        'all-facets': {
          outside: {
            openHTML: 'Afficher ({selectedFiltersCount}) filtres',
            closeHTML: 'Masquer filtres'
          }
        }

      }

    }
  },
  nextQueries: {
    titleHTML: ''
  },
  history: {
    disable: 'off',
    enable: 'on'
  },
  results: {
    addToCart: 'Ajouter au panier'
  }
};
